<template>
  <div>
    <v-container>
      <p class="headline white--text ml-5">Game status</p>
      <div v-if="$store.state.admin != ''" class="">
        <div class="text-center" v-if="pageLoading">
          <v-progress-circular
            :size="70"
            :width="2"
            color="grey"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-if="$store.state.whichToShow == 'Dogs'">
          <div
            v-if="!pageLoading"
            class="text-center white pa-16 pl-2 pr-2 pt-2"
            style="border-radius: 3px"
          >
            <v-layout
              id="gameStat"
              row
              wrap
              justify-space-around
              style="font-size: 18px"
            >
              <v-flex xs12 md6>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <v-layout
                      row
                      wrap
                      class="pt-3 pl-5 pr-5 text-left"
                      style="font-size: 14px"
                      justify-space-around
                    >
                      <v-flex xs6 md4 class="pa-1">
                        <p
                          class="orange--text"
                          style="font-size: 18px"
                          v-if="currentGame.length > 0"
                        >
                          Dog Game# {{ currentGame[0].game_number }}
                        </p>
                        <p class="orange--text" style="font-size: 18px" v-else>
                          No game
                        </p>
                      </v-flex>
                      <v-flex xs6 md4 class="pr-1 pt-2">
                        <p>
                          <v-progress-linear
                            v-model="timePercent"
                            height="8"
                          ></v-progress-linear>
                        </p>
                      </v-flex>
                      <v-flex
                        class="red--text pa-1"
                        xs12
                        md4
                        v-if="minutes == '00' && parseInt(seconds) <= 20"
                      >
                        <p>GAME CLOSES IN {{ minutes }}:{{ seconds }}</p>
                      </v-flex>

                      <v-flex class="pa-1" xs12 md4 v-else>
                        <p>GAME CLOSES IN {{ minutes }}:{{ seconds }}</p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Money</h4>
                    <span class="green--text">
                      {{ totalMoneyCurrentBets }}
                      <span style="font-size: 11px">ETB</span>
                    </span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Tickets</h4>
                    <span class="blue--text" v-if="currentGame.length > 0">
                      {{ currentGame[0].getTickets.length }}
                    </span>
                    <span class="pink--text" v-else>0 Number of tickets</span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Bet</h4>
                    <span class="blue--text" v-if="totalBetsCurrentGame > 0">
                      {{ totalBetsCurrentGame }}
                    </span>
                    <span class="pink--text" v-else>0 Number of Bets</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="$store.state.whichToShow == 'bingo'">
          <div
            v-if="!pageLoading"
            class="text-center white pa-16 pl-2 pr-2 pt-2"
            style="border-radius: 3px"
          >
            <v-layout
              id="gameStat"
              row
              wrap
              justify-space-around
              style="font-size: 18px"
            >
              <!-- <v-flex xs12 class="text-center ma-5">
                <v-btn
                  small
                  text
                  dark
                  class="pink mr-2"
                  @click="
                    stertGame(
                      $store.state.bingoAdminURL.split('graphql')[0] + 'getApp'
                    )
                  "
                >
                  <span class="text-capitalize">Start bingo</span>
                </v-btn>
                <span class="red--text" style="font-size: 14px"
                  >Make sure if last game time is less by 5 min and 22 sec, then
                  click only once!</span
                >
              </v-flex> -->
              <v-flex xs12 md6>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <v-layout
                      row
                      wrap
                      class="pt-3 pl-5 pr-5 text-left"
                      style="font-size: 14px"
                      justify-space-around
                    >
                      <v-flex xs6 md4 class="pa-1">
                        <p
                          class="orange--text"
                          style="font-size: 18px"
                          v-if="bingoCurrentGame.length > 0"
                        >
                          bingo Game# {{ bingoCurrentGame[0].game_number }}
                        </p>
                        <p class="orange--text" style="font-size: 18px" v-else>
                          No game
                        </p>
                      </v-flex>
                      <v-flex xs6 md4 class="pr-1 pt-2">
                        <p>
                          <v-progress-linear
                            v-model="bingoTimePercent"
                            height="8"
                          ></v-progress-linear>
                        </p>
                      </v-flex>
                      <v-flex
                        class="red--text pa-1"
                        xs12
                        md4
                        v-if="
                          bingoMinutes == '00' && parseInt(bingoSeconds) <= 20
                        "
                      >
                        <p>
                          GAME CLOSES IN {{ bingoMinutes }}:{{ bingoSeconds }}
                        </p>
                      </v-flex>

                      <v-flex class="pa-1" xs12 md4 v-else>
                        <p>
                          GAME CLOSES IN {{ bingoMinutes }}:{{ bingoSeconds }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Money</h4>
                    <span class="green--text">
                      {{ bingoTotalMoneyCurrentBets }}
                      <span style="font-size: 11px">ETB</span>
                    </span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Tickets</h4>
                    <span class="blue--text" v-if="bingoCurrentGame.length > 0">
                      {{ bingoCurrentGame[0].getTickets.length }}
                    </span>
                    <span class="pink--text" v-else>0 Number of tickets</span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md3>
                <v-card class="ma-2 pb-2" height="120px">
                  <v-card-text>
                    <h4>Current Bet</h4>
                    <span
                      class="blue--text"
                      v-if="bingoTotalBetsCurrentGame > 0"
                    >
                      {{ bingoTotalBetsCurrentGame }}
                    </span>
                    <span class="pink--text" v-else>0 Number of Bets</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>

      <div v-else id="error" class="text-center mt-16">
        <p class="red--text text-center">Please login first</p>
        <a @click="$router.push({ name: 'login' })">login</a>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      pageLoading: false,
      currentGame: [],
      timePercent: 0,
      timeInSeconds: 0,
      minutes: 9,
      seconds: "00",
      totalMoneyCurrentBets: 0,
      totalBetsCurrentGame: 0,

      bingoCurrentGame: [],
      bingoTimePercent: 0,
      bingoTimeInSeconds: 0,
      bingoMinutes: 9,
      bingoSeconds: "00",
      bingoTotalMoneyCurrentBets: 0,
      bingoTotalBetsCurrentGame: 0,
    };
  },

  methods: {
    async stertGame(url) {
      await axios.get(url);
    },
    // async getPendingGame() {
    //   this.pageLoading = true;
    //   try {
    //     var currentGameResult = await axios({
    //       method: "POST",
    //       url: this.$store.state.adminURL,

    //       data: {
    //         query: `{
    //             getPendingGame{
    //                game_id
    //                game_number
    //                game_number
    //                drawn_numbers
    //                game_date
    //                getTickets{
    //                  ticket_id
    //                  game_id
    //                  user_id
    //                  choosen_numbers
    //                  others
    //                  ticket_date
    //                  winner_award

    //                }
    //              }
    //           }
    //           `,
    //       },
    //     });
    //     this.currentGame = currentGameResult.data.data.getPendingGame;
    //     this.totalMoneyCurrentBets = 0;
    //     this.totalBetsCurrentGame = 0;
    //     if (this.currentGame.length > 0) {
    //       // alert(Date.now());
    //       for (let t = 0; t < this.currentGame[0].getTickets.length; t++) {
    //         var tickets =
    //           this.currentGame[0].getTickets[t].choosen_numbers.split(":");

    //         if (tickets[0] != "") {
    //           this.totalBetsCurrentGame =
    //             this.totalBetsCurrentGame + tickets.length;
    //           for (let j = 0; j < tickets.length; j++) {
    //             this.totalMoneyCurrentBets =
    //               this.totalMoneyCurrentBets +
    //               parseFloat(tickets[j].split("*")[3]);
    //           }
    //         }
    //       }

    //       if (this.currentGame.length > 0) {
    //         this.timeInSeconds = Math.floor(
    //           540 - (Date.now() - Number(this.currentGame[0].game_date)) / 1000
    //         );

    //         this.timePercent =
    //           0.1852 *
    //           Math.floor(
    //             (Date.now() - Number(this.currentGame[0].game_date)) / 1000
    //           );
    //       } else {
    //         this.timePercent = 0;
    //         this.minutes = "00";
    //         this.seconds = "00";
    //       }
    //     }
    //   } catch (err) {
    //     alert(err);
    //   }

    //   this.pageLoading = false;
    // },
    async bingoGetPendingGame() {
      this.pageLoading = true;
      try {
        var currentGameResult = await axios({
          method: "POST",
          url: this.$store.state.bingoAdminURL,

          data: {
            query: `{
                getPendingGame{
                   game_id                   
                   game_number                   
                   game_number
                   drawn_numbers
                   game_date
                   getTickets{
                     ticket_id
                     game_id
                     user_id
                     choosen_numbers
                     others
                     ticket_date
                     winner_award

                   }
                 }
              }
              `,
          },
        });
        this.bingoCurrentGame = currentGameResult.data.data.getPendingGame;
        this.bingoTotalMoneyCurrentBets = 0;
        this.bingoTotalBetsCurrentGame = 0;
        if (this.bingoCurrentGame.length > 0) {
          // alert(Date.now());
          for (let t = 0; t < this.bingoCurrentGame[0].getTickets.length; t++) {
            var tickets =
              this.bingoCurrentGame[0].getTickets[t].choosen_numbers.split(":");

            if (tickets[0] != "") {
              this.bingoTotalBetsCurrentGame =
                this.bingoTotalBetsCurrentGame + tickets.length;
              for (let j = 0; j < tickets.length; j++) {
                this.bingoTotalMoneyCurrentBets =
                  this.bingoTotalMoneyCurrentBets +
                  parseFloat(tickets[j].split("*")[3]);
              }
            }
          }

          if (this.bingoCurrentGame.length > 0) {
            this.bingoTimeInSeconds = Math.floor(
              220 -
                (Date.now() - Number(this.bingoCurrentGame[0].game_date)) / 1000
            );

            this.bingoTimePercent =
              0.45455 *
              Math.floor(
                (Date.now() - Number(this.bingoCurrentGame[0].game_date)) / 1000
              );
          } else {
            this.bingoTimePercent = 0;
            this.bingoMinutes = "00";
            this.bingoSeconds = "00";
          }
        }
      } catch (err) {
        alert(err);
      }

      this.pageLoading = false;
    },
  },

  async created() {
    if (this.$store.state.admin != "") {
      // await this.getPendingGame();
      await this.bingoGetPendingGame();

      // setInterval(async () => {
      //   if (this.timeInSeconds > 0) {
      //     this.timeInSeconds--;
      //     let hours = Math.floor(this.timeInSeconds / 3600);
      //     this.minutes = Math.floor((this.timeInSeconds - hours * 3600) / 60); // get minutes
      //     this.seconds = this.timeInSeconds - hours * 3600 - this.minutes * 60;

      //     if (this.minutes < 10) {
      //       this.minutes = "0" + this.minutes;
      //     }
      //     if (this.seconds < 10) {
      //       this.seconds = "0" + this.seconds;
      //     }

      //     this.timePercent = this.timePercent + 0.1852;
      //   } else {
      //     this.timePercent = 0;
      //     this.minutes = "00";
      //     this.seconds = "00";
      //   }
      // }, 1000);
      setInterval(async () => {
        if (this.bingoTimeInSeconds > 0) {
          this.bingoTimeInSeconds--;
          let hours = Math.floor(this.bingoTimeInSeconds / 3600);
          this.bingoMinutes = Math.floor(
            (this.bingoTimeInSeconds - hours * 3600) / 60
          ); // get minutes
          this.bingoSeconds =
            this.bingoTimeInSeconds - hours * 3600 - this.bingoMinutes * 60;

          if (this.bingoMinutes < 10) {
            this.bingoMinutes = "0" + this.bingoMinutes;
          }
          if (this.bingoSeconds < 10) {
            this.bingoSeconds = "0" + this.bingoSeconds;
          }

          this.bingoTimePercent = this.bingoTimePercent + 0.45455;
        } else {
          this.bingoTimePercent = 0;
          this.bingoMinutes = "00";
          this.bingoSeconds = "00";
        }
      }, 1000);
    } else this.$router.push({ name: "login" });
  },
};
</script>
<style scoped>
#error {
  max-width: 300px;
  margin: auto;
}

#gameStat {
  max-width: 1200px;
  margin: auto;
}
</style>
